import { DefaultService } from '@/services/DefaultService';

export default class UsuarioService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    getByIdUsuarioErp(idusuarioerp) {
        return this._http.get(`${this._env}/userweb/byidusuarioerp.json?idusuarioerp=${idusuarioerp}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }


}